import { Link } from "react-router-dom";
import { Button } from "@/components/ui/Button";

export default function NotFound() {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-3 bg-cream text-center">
      <h1 className="text-3xl font-semibold text-ink">404</h1>
      <p className="text-ink-muted">This page doesn't exist.</p>
      <Link to="/dashboard">
        <Button variant="outline">Back to dashboard</Button>
      </Link>
    </div>
  );
}
